/* BRANDSETS – „+” na kafelkach produktów = szybkie dodanie do koszyka
   (przycisk: snippets/product-badges.liquid, wygląd: assets/bs-cards.css)
   - produkt z jednym wariantem: dodaje od razu,
   - kilka wariantów: na zdjęciu pokazuje rozmiary (wyprzedane przekreślone,
     „na zamówienie” z kropką), kliknięcie rozmiaru dodaje do koszyka,
   - po dodaniu otwiera się koszyk boczny (ta sama ścieżka co na karcie produktu).
   Nasłuch jest na całym dokumencie, więc działa też na kafelkach doładowanych filtrami. */
(function () {
  if (window.__bsQuickAdd) return;
  window.__bsQuickAdd = true;

  var ICON_PLUS = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M8 3v10M3 8h10"/></svg>';
  var ICON_OK = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M3 8.5l3.2 3L13 4.5"/></svg>';
  var ICON_X = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M4 4l8 8M12 4l-8 8"/></svg>';

  function esc(t) {
    var d = document.createElement('div');
    d.textContent = t == null ? '' : String(t);
    return d.innerHTML;
  }

  function variantsOf(card) {
    var el = card.querySelector('script[data-product-variants-json]');
    try { return JSON.parse(el ? el.textContent : '[]') || []; } catch (e) { return []; }
  }

  function closeAll() {
    document.querySelectorAll('.bs-qa-pick').forEach(function (p) {
      var card = p.closest('product-card');
      p.remove();
      if (card) card.classList.remove('is-bs-picking');
    });
  }

  function openPick(card, btn, kb) {
    var vs = variantsOf(card);
    if (!vs.length) {
      var link = card.querySelector('a.product-card__link');
      if (link) window.location.href = link.href;
      return;
    }
    var pre = (btn.dataset.pre || '').split(',');
    var opt = (btn.dataset.opt || '').toLowerCase();
    var label = opt.indexOf('rozmiar') > -1 || opt.indexOf('size') > -1 || opt === '' ? 'Wybierz rozmiar' : 'Wybierz wariant';
    var anyPre = false;
    var chips = vs.map(function (v) {
      var isPre = v.available && pre.indexOf(String(v.id)) > -1;
      if (isPre) anyPre = true;
      var name = v.public_title || v.title;
      return '<button type="button" class="bs-qa-chip' + (isPre ? ' is-pre' : '') + '" data-id="' + v.id + '"' +
        (v.available ? '' : ' disabled aria-label="' + esc(name) + ' – brak"') + '>' + esc(name) + '</button>';
    }).join('');

    var p = document.createElement('div');
    p.className = 'bs-qa-pick';
    p.setAttribute('role', 'dialog');
    p.setAttribute('aria-label', label);
    p.innerHTML =
      '<div class="bs-qa-pick__h"><span>' + label + '</span>' +
      '<button type="button" class="bs-qa-pick__x" aria-label="Zamknij">' + ICON_X + '</button></div>' +
      '<div class="bs-qa-pick__list">' + chips + '</div>' +
      '<p class="bs-qa-pick__note"' + (anyPre ? '' : ' hidden') + '><i></i>na zamówienie, 2–14 dni roboczych</p>';
    btn.parentNode.insertBefore(p, btn);
    card.classList.add('is-bs-picking');
    /* fokus na pierwszy rozmiar tylko przy obsłudze klawiaturą (żeby przy kliknięciu myszką nie było obwódki) */
    var first = p.querySelector('.bs-qa-chip:not(:disabled)');
    if (first && kb) first.focus({ preventScroll: true });
  }

  function showError(card, btn, msg) {
    var note = card.querySelector('.bs-qa-pick__note');
    if (note) {
      note.hidden = false;
      note.classList.add('is-error');
      note.textContent = msg || 'Nie udało się dodać. Spróbuj jeszcze raz.';
    } else if (btn && btn.animate) {
      btn.animate([{ transform: 'translateX(-3px)' }, { transform: 'translateX(3px)' }, { transform: 'none' }], { duration: 300 });
      btn.title = msg || '';
    }
  }

  function add(card, btn, id, chip) {
    if (!card || !btn || !id) return;
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var fd = new FormData();
    fd.append('id', id);
    fd.append('quantity', '1');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.section; }));
      fd.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(btn);
    }
    var busy = chip || btn;
    busy.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if ((res.status && res.status !== 200) || res.errors) {
          throw new Error(res.description || res.message || res.errors);
        }
        closeAll();
        btn.classList.add('is-added');
        btn.innerHTML = ICON_OK;
        setTimeout(function () {
          btn.classList.remove('is-added');
          btn.innerHTML = ICON_PLUS;
        }, 1800);
        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(res);
        } else {
          window.location.href = '/cart';
        }
        if (typeof updateCartCounters === 'function') updateCartCounters();
        if (typeof updateFreeShipping === 'function') updateFreeShipping();
      })
      .catch(function (err) {
        console.error('[bs-quick-add]', err);
        showError(card, btn, err && err.message);
      })
      .finally(function () {
        busy.classList.remove('is-loading');
      });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var btn = t.closest('[data-bs-qa]');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      var card = btn.closest('product-card');
      if (!card) return;
      if (btn.dataset.variantId) { add(card, btn, btn.dataset.variantId, null); return; }
      closeAll();
      openPick(card, btn, e.detail === 0);
      return;
    }

    if (t.closest('.bs-qa-pick__x')) {
      e.preventDefault();
      e.stopPropagation();
      var c = t.closest('product-card');
      closeAll();
      var b = c && c.querySelector('[data-bs-qa]');
      if (b && e.detail === 0) b.focus({ preventScroll: true });
      return;
    }

    var chip = t.closest('.bs-qa-chip');
    if (chip) {
      e.preventDefault();
      e.stopPropagation();
      if (chip.disabled) return;
      var card2 = chip.closest('product-card');
      add(card2, card2 && card2.querySelector('[data-bs-qa]'), chip.dataset.id, chip);
      return;
    }

    if (t.closest('.bs-qa-pick')) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    if (document.querySelector('.bs-qa-pick')) closeAll();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.querySelector('.bs-qa-pick')) closeAll();
  });
})();
